import React from "react";

import { useRouteMatch } from "react-router-dom";

import { observer } from "mobx-react";

import { EventFooterCore } from ".";

export const EventFooter = observer(function EventFooter() {
	const match = useRouteMatch("/:culture/live/:period/:eventIds+");

	if (!match) {
		return null;
	}

	return <EventFooterCore />;
});
